import { render } from "./IconForkLift.vue?vue&type=template&id=43f7ffbc"
import script from "./IconForkLift.vue?vue&type=script&lang=ts"
export * from "./IconForkLift.vue?vue&type=script&lang=ts"
script.render = render

export default script